import requestTypes from "constants/requestTypes";
import { PredefinedTableDetail } from "./models/predefinedTableDetail";
import { PredefinedTable } from "./models/predefinedTable";
import { fetchNext } from "./request";

const APP_WORKSPACE_URL = String(process.env.REACT_APP_WORKSPACE_URL);

export const getPredefinedTables = async (): Promise<PredefinedTable> => {
  const url = APP_WORKSPACE_URL + "/predefined_tables";
  const resp = await fetchNext(requestTypes.GET, url, null);
  return resp;
};

export const getPredefinedTablesById = async (predefinedTableId: number): Promise<PredefinedTableDetail> => {
  const url = `${APP_WORKSPACE_URL}/predefined_tables/${predefinedTableId}`;
  const resp = await fetchNext(requestTypes.GET, url, null);
  return resp;
};

